module.exports = __webpack_public_path__ + "images/unlisted-black-1000bba4.svg";